export const CHAH = {
    cta: {
    // select: 'CHAH SELECT',
    },
    contact_card: {
        showPrices: {
            title: 'Your Details',
            form_title: 'Check prices',
            submit_text: 'Submit details',
            subtitle:
        'Please enter your details and we’ll show you our best price and email a personalised quote.',
        },
    },
};
